import { http } from "../util/http";
import Util from "../util";
import { toFormData } from "../util/FormData";

export default class BundleService {
  static paginate(filters) {
    return http.get(`/adventures-data-entry/bundles/?${Util.toQuery(filters)}`);
  }

  static get(id) {
    return http.get(`/adventures-data-entry/bundles/${id}/`);
  }

  static add(bundle) {
    return http.post(
      "/adventures-data-entry/bundles/",
      toFormData(bundle, { brackets: false })
    );
  }

  static update(id, data) {
    if (typeof data["cover_image"] == 'string') {
      delete data["cover_image"];
    }
    return http.patch(
      `/adventures-data-entry/bundles/${id}/`,
      toFormData(data, { brackets: false })
    );
  }

  static delete(id) {
    return http.delete(`/adventures-data-entry/bundles/${id}/`);
  }

  static clearCache() {
    return http.get(`/clear_cache/`);
  }
}
